// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProgressBar.css */
.App-bar {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}

.progress-bar-container {
  position: relative;
  width: 80%;
  max-width: 400px; /* Set maximum width for desktop */
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
  margin: 0 auto; /* Center align in its container */
  /* margin-bottom: 1rem; Add some margin below for spacing */
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #3b82f6;
  border-radius: 10px;
  transition: width 0.3s ease-in-out;
}

.marker {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .progress-bar-container {
    height: 20px; /* Reduce height */
    /* margin-top: -80px; Increase margin-bottom for mobile */
  }

  .marker {
    width: 30px;
    height: 30px;
    font-size: 12px; 
  }
}

@media (max-width: 480px) {
  .progress-bar-container {
    height: 18px; /* Further reduce height */
    /* margin-top: -20px; Further increase margin-bottom for mobile */
  }

  .marker {
    width: 28px;
    height: 28px; /* Slightly decrease height */
    font-size: 11px; /* Slightly decrease font size */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgressBar/ProgressBar.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB,EAAE,kCAAkC;EACpD,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc,EAAE,kCAAkC;EAClD,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY,EAAE,kBAAkB;IAChC,yDAAyD;EAC3D;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY,EAAE,0BAA0B;IACxC,iEAAiE;EACnE;;EAEA;IACE,WAAW;IACX,YAAY,EAAE,6BAA6B;IAC3C,eAAe,EAAE,gCAAgC;EACnD;AACF","sourcesContent":["/* ProgressBar.css */\n.App-bar {\n  width: 100%;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.progress-bar-container {\n  position: relative;\n  width: 80%;\n  max-width: 400px; /* Set maximum width for desktop */\n  height: 20px;\n  background-color: #e0e0e0;\n  border-radius: 10px;\n  cursor: pointer;\n  margin: 0 auto; /* Center align in its container */\n  /* margin-bottom: 1rem; Add some margin below for spacing */\n}\n\n.progress-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: #3b82f6;\n  border-radius: 10px;\n  transition: width 0.3s ease-in-out;\n}\n\n.marker {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .progress-bar-container {\n    height: 20px; /* Reduce height */\n    /* margin-top: -80px; Increase margin-bottom for mobile */\n  }\n\n  .marker {\n    width: 30px;\n    height: 30px;\n    font-size: 12px; \n  }\n}\n\n@media (max-width: 480px) {\n  .progress-bar-container {\n    height: 18px; /* Further reduce height */\n    /* margin-top: -20px; Further increase margin-bottom for mobile */\n  }\n\n  .marker {\n    width: 28px;\n    height: 28px; /* Slightly decrease height */\n    font-size: 11px; /* Slightly decrease font size */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
